// src/components/pos/Reports.jsx
// POS Reports Component - Comprehensive reports with thermal printer support

import { useState } from 'react'
import { FileText, Printer } from 'lucide-react'
import { cn } from '../../utils/cn'
import { POSButton } from './ui/Button'
import AllReportsModal from '../modals/AllReportsModal'

const Reports = ({ className, selectedBranch, ...props }) => {
  const [loading, setLoading] = useState(false)
  const [showReportsModal, setShowReportsModal] = useState(false)

  const handleReportClick = () => {
    setShowReportsModal(true)
  }

  return (
    <>
      <POSButton
        variant="default"
        className={cn(
          "h-20 flex-col space-y-2 bg-gray-900 text-white hover:bg-gray-600 border-gray-700",
          loading && "opacity-50 cursor-not-allowed",
          className
        )}
        onClick={handleReportClick}
        disabled={loading}
        {...props}
      >
        <div className="flex items-center space-x-1">
          <FileText className="h-6 w-6" />
          {loading && (
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
          )}
        </div>
        <span className="text-sm font-medium">
          Reports
        </span>
      </POSButton>

      {/* All Reports Modal */}
      <AllReportsModal
        isOpen={showReportsModal}
        onClose={() => setShowReportsModal(false)}
        branchId={selectedBranch?._id}
        branchInfo={selectedBranch}
      />
    </>
  )
}

export default Reports